<template>
  <div class="rulesTextModal">
    <div class="d-flex flex-column">
      <div class="quill-title">
        <span class="required text-bold">Title</span>
        <quill-editor ref="titleQuill" v-model="form.title"  @change="handleQuillChange('titleQuill', 50)" :options="quillEditorOptions" />
        <div class="text-count">{{ titleCharCount }} / 50</div>
      </div>
      <div class="quill-text">
        <span class="required text-bold">Text</span>
        <quill-editor ref="textQuill" v-model="form.text"  @change="handleQuillChange('textQuill', 20000)" :options="quillEditorOptions" />
        <div class="text-count">{{ textCharCount }} / 20000</div>
      </div>
    </div>
    <hr>
    <a-row>
      <a-col :span="24" class="text-right">
        <a-button @click="closeModal">
          Cancel
        </a-button>
        <a-button type="primary" :disabled="isSaveDisabled" style="margin-left: 10px;" @click="saveRules"
          :loading="loading">
          Save
        </a-button>
      </a-col>
    </a-row>
  </div>
</template>
<script>

import { quillEditor } from 'vue-quill-editor'

export default {
  name: 'RulesModal',
  props: {
    rulesObject: {
      type: Object,
    },
  },
  components: {
    quillEditor,
  },
  data() {
    return {
      form: {
        title: '',
        text: '',
      },
      loading: false,
      quillEditorOptions: {
        placeholder: 'Input description',
        modules: {
          toolbar: [
            ['bold', 'italic', 'underline'], // toggled buttons
            ['blockquote'],

            [{ list: 'ordered' }, { list: 'bullet' }],
            [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
            [{ direction: 'rtl' }], // text direction
            [{ header: [1, 2, 3, 4, 5, 6, false] }],
            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ align: [] }],

            ['link'],
          ],
        },
      },
    }
  },
  computed: {
    isSaveDisabled() {
      return this.titleCharCount === 0 || this.textCharCount === 0
    },
    titleCharCount() {
      const div = document.createElement('div')
      div.innerHTML = this.form.title || ''
      return div.textContent.length
    },
    textCharCount() {
      const div = document.createElement('div')
      div.innerHTML = this.form.text || ''
      return div.textContent.length
    },
  },
  async created() {
    if (this.rulesObject) {
      this.form.title = this.rulesObject.title
      this.form.text = this.rulesObject.text
    }
  },
  methods: {
    handleQuillChange(refName, maxLength) {
      const quill = this.$refs[refName]?.quill
      if (!quill) return

      const plainText = quill.getText()
      if (plainText.length > maxLength) {
        quill.deleteText(maxLength, plainText.length)
      }
    },
    saveRules() {
      this.$emit('createdRules', this.form)
    },
    closeModal () {
      this.$emit('closeTemplateModal')
    },
  },
}
</script>
<style scoped>
  .text-count {
    height: 30px;
    color: #BFBFBF;
    text-align: end;
  }
</style>
